<template>
  <div class="home">
    <HeaderView />

    <section id="blog-content-wrapper">
      <div class="container">
        <div class="blog-single-header">
          <h1>{{ $t('transportLogistics.title') }}</h1>
          <div class="img-wrapper">
            <img src="../assets/images/warehouse.jpg" :alt="$t('transportLogistics.imageAlt')" />
          </div>
        </div>
        <div class="blog-single-body">
          <p class="p">{{ $t('transportLogistics.paragraph1') }}</p>
          <p class="p">{{ $t('transportLogistics.paragraph2') }}</p>
          <p class="p">{{ $t('transportLogistics.paragraph3') }}</p>
        </div>
      </div>
    </section>

    <AccordianView />
    <GetQoute/>
    <FooterView />
  </div>
</template>

<script>
// @ is an alias to /src
import HeaderView from "@/components/UiComponents/HeaderView.vue";
import AccordianView from "@/components/UiComponents/AccordianView.vue";
import FooterView from "@/components/UiComponents/FooterView.vue";
import GetQoute from "@/components/UiComponents/GetQoute.vue";

export default {
  name: "TransportLogistics",
  components: {
    HeaderView,
    AccordianView,
    GetQoute,
    FooterView,
  },
};
</script>
